import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PickedResult, LookupGridComponent, ServerSideToken } from '@farris/ui-lookup';
import { WfReportDefHelpService } from './wf-report-def-help.service';
import { WfLocalePipe } from '../../../../../i18n/pipe/wf-process-editor-locale.pipe';

@Component({
  selector: 'app-wf-report-def-help',
  template: `
    <farris-lookup-grid #lookup
      [disabled]="disabled"
      [editable]="false"
      [bindingData]="bindingData"
      [(ngModel)]="displayTxt"
      [columns]="columns"
      [singleSelect]="singleSelect"
      title="title"
      [displayType]="'List'"
      [uri]="dataUri"
      [idField]="'id'"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pagination]="pagination"
      [valueField]="'id'"
      [textField]="'name'"
      (clear)="afterClear($event)"
      [dialogWidth]="width"
      [dictPicking]="beforeOpen"
      [dictPicked]="dictPicked">
    </farris-lookup-grid>
  `,
  styles: [],
  providers: [{ provide: ServerSideToken, useClass: WfReportDefHelpService }]
})
export class WfReportDefHelpComponent implements OnInit {
  /** 标题 */
  @Input() title: string;
  /** 宽度 */
  @Input() width = 550;
  /** 取数源 */
  @Input() sourceType: 'matrixField';
  /** 只读 */
  @Input() disabled = false;
  /** 是否单选 */
  @Input() singleSelect = true;
  /** 是否分页，默认true */
  @Input() pagination = true;
  /** 首次加载第几页，默认1 */
  @Input() pageIndex = 1;
  /** 每页加载数，默认20 */
  @Input() pageSize = 20;
  /** 绑定到帮助上的数据，初始显示值用 */
  @Input() displayTxt: string;
  /** 存储帮助选择的对象 */
  @Input() bindingData: { id: string, name: string };
  /** 过滤条件 */
  @Input() filter: any = {};

  // @Input() beforeClose: (selectData: any) => Observable<PickedResult>;
  /** 帮助选择后事件 */
  @Output() afterConfirm: EventEmitter<any> = new EventEmitter<any>();
  @Output() dialogClosed: EventEmitter<any> = new EventEmitter<any>();
  @Output() clear: EventEmitter<any> = new EventEmitter<any>();
  dataUri: string;
  columns: any[] = [];

  @ViewChild('lookup') public lookUp: LookupGridComponent;

  constructor(
    private localePipe: WfLocalePipe
  ) { }

  ngOnInit() {
    this.columns = [
      { title: this.localePipe.transform('component.reportingLine.code'), field: 'code', width: '80', searchField: 'code', },
      { title: this.localePipe.transform('component.reportingLine.name'), field: 'name', width: '100', searchField: 'name', }
    ];
    // this.dataUri = this.uiState.dataUri;
    this.dataUri = '/api/runtime/wf/v1.0/reportingLineDefinitions/query';
    // 必须要有，否则初始选中不起作用
    this.lookUp.mapFields = { id: 'id', name: 'name' };
  }

  afterClear(arg: any) {
    this.clear.next(arg);
  }

  /** 帮助前事件,强行传递过滤条件 */
  beforeOpen = (arg) => {
    // 把过滤数据和当前的数据传递到service层
    return of({
      showDialog: true, data: {
        filter: this.filter
      }
    });
  }
  dictPicked = (arg: any): Observable<PickedResult> => {
    this.afterConfirm.next(arg);
    return of({ closeDialog: true });
  }


  /** 手动显示帮助 */
  public showHelp() {
    this.lookUp.showDialog();
  }
}
